module.exports = __webpack_public_path__ + "img/gamefund-portfolio.e0c05435.jpg";